import * as React from 'react';
import { Chip } from '@material-ui/core';
import { Task, TaskStatus } from 'task-manager/types';
import { useStyles } from './StatusChip.styles';

const statusColorLookup: Record<TaskStatus | string, string> = {
  PENDING_WORK: 'pendingWork',
  PAUSED: 'paused',
  RESOLVED: 'resolved',
  ASSIGNED: 'assigned',
};

const statusText = {
  PENDING_WORK: 'To Do',
  PAUSED: 'Paused',
  RESOLVED: 'Done',
  ASSIGNED: 'Assigned to',
};

type StatusChipProps = {
  status: Task['status'];
  assignedPerson: Task['assignedPerson'];
};

export const StatusChip = ({ status, assignedPerson }: StatusChipProps) => {
  const classes = useStyles();
  const statusColor = statusColorLookup[assignedPerson?.fullName ? 'ASSIGNED' : status];
  const showAssigned = status === TaskStatus.PENDING_WORK && assignedPerson?.fullName;
  const text = showAssigned
    ? `${statusText.ASSIGNED} ${assignedPerson.fullName}`
    : statusText[status];

  return <Chip label={text} size="small" className={classes[statusColor]} />;
};
